import React, { useState, useRef, useEffect } from 'react';

import {
  Box,
  Paper,
  TextField,
  Grid,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  styled,
  Button,
  Divider,
} from '@mui/material';

// import {
//     LoadingButton
// } from '@mui/lab';

import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';

// import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../../common/CommonRestricted';

import { useAppContextFeatures } from '../../../../context/AppContext';
import { useSystemPrompt } from '../../../../hooks/useSystemPrompt';

import { useRegions, regionTypes } from '../../../../hooks/api/useRegions';
import { useRates, rateTypes, targetTypes } from '../../../../hooks/api/useRates';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../hooks/usePermissions';
import { useTranslations } from '../../../../hooks/useTranslations';

import {
  initialValues,
  initialRowValues,
  validationSchema,
  measureMethods,
} from '../../../../schema/rates/shipping/areaItemSchema';

const StyledCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default function AddNewArea({
  routeType,
  rateId,
  locationId,
  locationName,
  stateId,
  stateName,
  excludeAreaIds = [],
  handleOnSuccess,
}) {
  const { t } = useTranslations({ ns: ['common', '@rate'] });

  const { id } = useParams();
  const { promptMessage } = useSystemPrompt();
  const { list: listRules, update: updateRateItems } = useRates({
    rateType: rateTypes.shippingRule,
    targetType: targetTypes.shippingRule,
  });
  const { isPermissionAllow } = usePermissions(
    routeType,
    scopeIds.rate.id,
    scopeTypes[scopeIds.rate.id].shippingRate.id
  );

  const { setSystemLoading } = useAppContextFeatures();

  const { list: listRegions, filterOperatorTypes } = useRegions({});
  const [dataCountries, setDataCountries] = useState([]);

  const [dataAreas, setDataAreas] = useState([]);
  const [dataRules, setDataRules] = useState([]);

  const fetchAreas = async (stateId) => {
    setSystemLoading(true);

    try {
      const props = {
        limit: -1,
        skip: 0,
        filterValue: [
          // {
          //     name: "user_id",
          //     operator: filterOperatorTypes.eq,
          //     value: parentId
          // }
        ],
        sortInfo: {
          id: 'id',
          dir: 0,
        },
        regionType: regionTypes.area,
        stateId,
      };

      const { data } = await listRegions(props);

      let areas = data?.areas ? data.areas : [];

      // exclude the area ids (if any)
      let selectedAreas = areas.filter((i) => !excludeAreaIds.includes(i?.id));

      setDataAreas(selectedAreas);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }

    // try {

    //     const { data } = await get({ id })
    //     const { rate, items } = data;

    //     setSavedValues({
    //         rateName: rate.rate_name,
    //         locationId: rate.scope_id,
    //         description: rate.description,
    //         status: rate?.status === "1"
    //     })

    // } catch (error) {
    //     promptMessage(false, `${error?.message}`)
    // }

    setSystemLoading(false);
  };

  const fetchRules = async () => {
    setSystemLoading(true);

    try {
      const props = {
        limit: -1,
        skip: 0,
        filterValue: [
          // {
          //     name: "user_id",
          //     operator: filterOperatorTypes.eq,
          //     value: parentId
          // }
        ],
        sortInfo: {
          id: 'id',
          dir: 0,
        },
        // regionType: regionTypes.area,
        // stateId
      };

      const { data } = await listRules(props);

      console.log('data', data);

      setDataRules(data?.shipping_rules ? data.shipping_rules : []);

      // insert formik states
      let rows = [];

      measureMethods.forEach((i, index) => {
        rows.push({
          ...initialRowValues,
          ruleId: '',
          id: i?.id,
          name: t(i?.name),
        });
      });

      setFieldValue(`rateId`, rateId);
      setFieldValue(`locationId`, locationId);
      setFieldValue(`locationName`, locationName);
      setFieldValue(`rows`, rows);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }

    setSystemLoading(false);
  };

  const onSubmit = async (currentValues) => {
    let items = [];

    currentValues.rows.map((item) => {
      items.push({
        scope_type: 'area',
        scope_id: currentValues?.areaId,
        props: {
          rule_id: [item?.ruleId],
          to_location_id: currentValues?.locationId,
          measure_type: item?.id,
        },
      });
      return false;
    });

    try {
      let data = {
        // rate: [],
        items,
      };

      const response = await updateRateItems({
        id: currentValues?.rateId,
        targetType: targetTypes.shippingRate,
        data,
      });

      promptMessage(true, `${response?.message}`);

      if (handleOnSuccess) handleOnSuccess();
    } catch (error) {
      promptMessage(false, `Action Failed. (${error?.message})`);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit,
  });

  const { touched, values, errors, handleChange, handleSubmit, setFieldValue } = formik;

  useEffect(() => {
    fetchAreas(stateId);
    fetchRules();
  }, []);

  const RenderFormRules = () => {
    return (
      <>
        {values?.rows.map((item, index) => {
          const itemValues = item;

          let itemTouched = touched?.rows;
          let itemErrors = errors?.rows;
          // const itemTouched = touched?.rows

          if (itemTouched) {
            itemTouched = itemTouched[index] !== undefined ? itemTouched[index] : {};
          }

          if (itemErrors) {
            itemErrors = itemErrors[index] !== undefined ? itemErrors[index] : {};
          }

          // getting available rules
          const availableRules = dataRules.filter((i) => i.measure_type === itemValues?.id);

          return (
            <Grid key={index} container spacing={1}>
              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                sx={{
                  fontWeight: 600,
                  mt: 2,
                }}
              >
                {item.name}
              </Grid>

              <Grid item xs={12} sm={12} md={9}>
                {/* {JSON.stringify(errors)} */}
                <FormControl margin="dense" fullWidth size="small" error={Boolean(itemErrors?.ruleId)}>
                  <InputLabel id="ruleId">{t('rules')}</InputLabel>
                  <Select
                    labelId="ruleId"
                    label={t('rules')}
                    name={`rows.${index}.ruleId`}
                    onChange={(event) => {
                      let value = event.target.value;

                      setFieldValue(`rows.${index}.ruleId`, event.target.value);
                    }}
                    // value={""}
                    value={itemValues.ruleId ? itemValues.ruleId : ''}
                  >
                    {availableRules?.map((i, index) => {
                      return (
                        <MenuItem key={index} value={i.id}>
                          {i.rule_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>{itemErrors?.ruleId}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          );
        })}
      </>
    );
  };

  const RenderArea = () => {
    return (
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          sx={{
            fontWeight: 600,
            mt: 2,
          }}
        >
          {t('area')}
        </Grid>

        <Grid item xs={12} sm={12} md={9} textAlign={'left'}>
          <FormControl margin="dense" fullWidth size="small" error={Boolean(errors.areaId)}>
            <InputLabel id="areaId">{t('area')}</InputLabel>
            <Select
              labelId="areaId"
              label={t('area')}
              name={'areaId'}
              onChange={(event) => {
                setFieldValue(`areaId`, event.target.value);
              }}
              value={values.areaId ? values.areaId : ''}
            >
              {dataAreas?.map((i, index) => {
                return (
                  <MenuItem key={index} value={i.id}>
                    {/* <ListItemText 
                                                            primary={`${i.location_name}`}
                                                        /> */}
                    {i.area_name}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>{errors.areaId}</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    );
  };

  const RenderForm = () => {
    return (
      <form onSubmit={formik.handleSubmit}>
        {/* {JSON.stringify(values)} */}
        <StyledCard>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <RenderArea />
            </Grid>

            <Grid item xs={12} sm={12} md={12} sx={{ mb: 2, mt: 2 }}>
              <Divider>{t('measureMethodRules')}</Divider>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <RenderFormRules />
            </Grid>
          </Grid>
        </StyledCard>

        <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
          <Grid item md={12} textAlign={'right'}>
            <Button
              type="submit"
              // fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
              // loading={isLoading}
              // onClick={() => {
              //     if (handleOnSuccess) handleOnSuccess()
              // }}
            >
              {t('saveChanges')}
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  return (
    <Box>{isPermissionAllow({ functionType: functionTypes.pageNew.id }) ? RenderForm() : <CommonRestricted />}</Box>
  );
}
